"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleEmailField = void 0;
const handleEmailField = ({ value, name, options, context }) => {
    if (options.email) {
        const regex = /^(([^<>()[\]\\.,;:\s@\\"]+(\.[^<>()[\]\\.,;:\s@\\"]+)*)|(\\".+\\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (regex.test(value)) {
            context.actions?.clearError(name);
            return true;
        }
        context.actions?.setError(name, { message: options.email.message });
        return false;
    }
    return true;
};
exports.handleEmailField = handleEmailField;
